import React from 'react';
const Privacy = (props: any) => {
  return (
    <div className="privacy-background">
      <div className="container">
        <div dangerouslySetInnerHTML={{ __html: props.data.description }} />
      </div>
    </div>
  );
};

export default Privacy;
